<template>
  <SalesDashboardCard title="Books (tags)" class-card="col-md-4" @set-filter="setFilter" :selected-filter="selectedFilter" :filters="filters">
    <div slot="body">
      <Loader v-if="loading" />
      <div v-else-if="tags && tags.length > 0" class="d-flex justify-content-between">
        <div class="d-flex flex-column pr-1">
          <div v-for="(tag, i) in tags.slice(0, parseInt(tags.length / 2))" :key="i" class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <span class="tag-color" :style="{'background-color': tag.tag_color}" />
              <span class="tag-name">{{ tag.tag_name }}</span>
            </div>

            <span class="d-inline-block ml-2">{{ tag.count_jobs }}</span>
          </div>
        </div>
        <div class="d-flex flex-column pr-1">
          <div v-for="(tag, i) in tags.slice(parseInt(tags.length / 2), tags.length)" :key="i" class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <span class="tag-color" :style="{'background-color': tag.tag_color}" />
              <span class="tag-name">{{ tag.tag_name }}</span>
            </div>

            <span class="d-inline-block ml-2">{{ tag.count_jobs }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <p class="text-center">There are no jobs.</p>
      </div>
    </div>
  </SalesDashboardCard>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import SalesDashboardCard from '../SalesDashboardCard';
import Loader from './Loader';

const filters = [
  {
    name: 'Today',
    date: '',
    to: moment().format('YYYY-MM-DD'),
    from: moment().format('YYYY-MM-DD'),
  },
  {
    name: 'Yesterday',
    date: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    from: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last week',
    date: '',
    from: moment()
      .subtract(1, 'weeks')
      .weekday(1)
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'weeks')
      .weekday(7)
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last month',
    date: '',
    from: moment()
      .subtract(1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('YYYY-MM-DD'),
  },
];

export default {
  components: { SalesDashboardCard, Loader },
  data() {
    return {
      filters,
      selectedFilter: filters[0],
      loading: false,
      tags: [],
    };
  },
  watch: {
    selectedFilter() {
      this.getTags();
    },
  },
  mounted() {
    this.getTags();
  },
  methods: {
    getTags() {
      this.loading = true;
      axios
        .get(
          `/sales/count-jobs/tags?date=${this.selectedFilter.date}&date_from=${
            this.selectedFilter.from
          }&date_to=${this.selectedFilter.to}`,
        )
        .then(res => {
          if (res.data.data.length > 0) {
            this.tags = res.data.data;
          } else {
            this.tags = [];
          }
          this.tags = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setFilter(filter) {
      this.selectedFilter = filter;
    },
  },
};
</script>

<style scoped>
.tag-color {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  display: inline-block;
  margin-right: 0.8rem;
}

.tag-name {
  color: #bec0ca;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/cards/BooksTags.vue